/**
 * Account access rules shared by the authentication gate and protected routes.
 * Student lifecycle status is the source of truth for student access; the
 * user-profile status remains the account-level status used by staff users.
 */
export const LOGIN_ALLOWED_STUDENT_STATUSES = ['pending', 'admitted', 'active'];

export const normalizeAccountStatus = (value) =>
  String(value || '').trim().toLowerCase();

export const isStudentLoginAllowed = (studentStatus, profileStatus) => {
  const effectiveStatus = normalizeAccountStatus(studentStatus || profileStatus);
  return LOGIN_ALLOWED_STUDENT_STATUSES.includes(effectiveStatus);
};

export const mapStudentStatusToProfileStatus = (studentStatus) => {
  switch (normalizeAccountStatus(studentStatus)) {
    case 'pending': return 'pending';
    case 'suspended': return 'suspended';
    case 'active':
    case 'admitted': return 'active';
    default: return 'inactive';
  }
};

export const isProfileLoginAllowed = (profile) => {
  if (!profile) return false;

  const role = normalizeAccountStatus(profile.primary_role);
  if (role === 'student') {
    return isStudentLoginAllowed(profile.student_status, profile.status);
  }

  return normalizeAccountStatus(profile.status) === 'active';
};

export const accountStatusMessage = (profile) => {
  const status = normalizeAccountStatus(profile?.student_status || profile?.status);
  if (status === 'suspended') {
    return 'This account is suspended and cannot sign in. Please contact the administrator for assistance.';
  }
  if (status === 'pending') {
    return 'This account is pending admission activation. Please contact the administrator before trying again.';
  }
  if (status === 'inactive' || status === 'deactivated' || status === 'withdrawn') {
    return 'This account is inactive and cannot sign in. Please contact the administrator to reactivate it.';
  }
  return 'This account is not eligible to sign in. Please contact the administrator for assistance.';
};
